import { useState } from 'react';
import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { addUser } from 'src/config/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { ADD_USER, UPDATE_USER } from 'src/apiService/apiDeclaration';
import CustomTextField from 'src/components/formFields/textField';
import LoaderButton from 'src/components/loaderButton/loaderButton';
import { showErrorTost, showSuccessTost } from 'src/constants';
import CustomSelectField from 'src/components/formFields/selectField';
import { roleArray } from 'src/constants';
import { t } from 'i18next';
const AddUserForm = ({ onSuccess, data }) => {
  const [loading, setLoading] = useState(false);
  const defaultValues = {
    firstName: data?.firstName,
    lastName: data?.lastName,
    email: data?.email,
    role: data?.role || 'default',
    phoneNumber: data?.phoneNumber,
  };

  const {
    handleSubmit,
    control,
    formState: { errors, isValid, isDirty },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(addUser),
    defaultValues,
  });

  const onSubmit = async (body) => {
    setLoading(true);
    try {
      let resp;
      if (data) {
        resp = await UPDATE_USER(data._id, body);
      } else {
        resp = await ADD_USER(body);
      }
      showSuccessTost(resp.message);
      onSuccess();
    } catch (error) {
      showErrorTost(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <CustomTextField
            label={'Email'}
            placeholder={t('common.placeholderEmail')}
            type="email"
            controller={{
              name: 'email',
              control: control,
              errors: errors.email,
            }}
            sx={{
              width: '100%',
              minWidth: {
                sm: '300px',
                xs: '200px',
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomSelectField
            label={t('common.role')}
            optionsArray={roleArray}
            controller={{
              name: 'role',
              control: control,
              errors: errors.role,
            }}
            sx={{
              width: '100%',
              minWidth: {
                sm: '300px',
                xs: '200px',
              },
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <LoaderButton
            disabled={!isValid || !isDirty}
            loading={loading}
            buttonText={data ? t('common.edit') : t('common.add')}
            type="submit"
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default AddUserForm;
